import { type Dispatch, useEffect } from 'react';

import { getLastSearchCar } from '../../common/lastSearch';
import actions from '../carActions';
import type { CarState } from '../carDefaultState';

export const useCarInitialState = (dispatch: Dispatch<ReturnType<(typeof actions)[keyof typeof actions]>>, prefill?: Partial<CarState>) => {
    useEffect(() => {
        dispatch(actions.allFieldsChanged({ ...getLastSearchCar(), ...prefill }));
    }, [dispatch, prefill]);
};
